import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationDialogComponent } from '@fuse/Dialog/confirmation-dialog/confirmation-dialog.component';
import { ToolbarService } from 'app/layout/components/toolbar/toolbar.service';
import { EmailTemplateApiService } from '../email-template-api.service';
import { EmailTemplateApiError, TemplateListItem } from '../models';
import { listItemStatus, STATUS_LABELS, TemplateStatus } from '../utils/status';

@Component({
    selector: 'app-template-list',
    templateUrl: './template-list.component.html',
    styleUrls: ['./template-list.component.scss']
})
export class TemplateListComponent implements OnInit {

    displayedColumns: string[] = ['title', 'subject', 'status', 'updatedAt', 'action'];
    templates: TemplateListItem[] = [];
    loading = false;
    errorMessage = '';

    constructor(
        private _emailTemplateApi: EmailTemplateApiService,
        private _toolbarService: ToolbarService,
        private _matDialog: MatDialog,
        private _matSnackBar: MatSnackBar,
        private _router: Router,
    ) {
        this._toolbarService._ToolBarTitle.next('Email Templates');
        this._toolbarService._isBackBtnShow.next(false);
    }

    ngOnInit(): void {
        this.loadTemplates();
    }

    loadTemplates(): void {
        this.loading = true;
        this.errorMessage = '';
        this._emailTemplateApi.getAll().then((templates) => {
            this.templates = templates;
        }, (error: EmailTemplateApiError) => {
            this.templates = [];
            this.errorMessage = error.status === 403
                ? 'Email templates are only available to the main admin account.'
                : error.message;
        }).finally(() => this.loading = false);
    }

    status(item: TemplateListItem): TemplateStatus {
        return listItemStatus(item);
    }

    statusLabel(item: TemplateListItem): string {
        return STATUS_LABELS[this.status(item)];
    }

    onOpen(item: TemplateListItem): void {
        if (!item.defaultAvailable) {
            return;
        }
        this._router.navigate(['/email-templates/edit', item.templateKey]);
    }

    onDelete(item: TemplateListItem): void {
        this._matDialog.open(ConfirmationDialogComponent, {
            panelClass: ['commonDialogWrapper'],
            backdropClass: 'dialogBackdrop',
            disableClose: false,
            data: {
                message: 'The platform template is no longer available, so this version can no longer be used. Delete it? This cannot be undone.',
                image: '/assets/ui/delete.png',
                focus: 'right',
                deleteItem: 'Delete my version?',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }
        }).afterClosed().subscribe((result) => {
            if (!result) {
                return;
            }
            this._emailTemplateApi.delete(item.templateKey).then((result) => {
                this._matSnackBar.open(result.message || 'Deleted successfully.', 'OK', { duration: 2000 });
                this.loadTemplates();
            }, (error: EmailTemplateApiError) => {
                this._matSnackBar.open(error.message, 'OK', { duration: 4000 });
            });
        });
    }
}
